export default "__VITE_ASSET__D$mbP55X__"